import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-shopping-cart.png'


const _withScopeId = n => (_pushScopeId("data-v-296e4d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { shoppingCartStore } from '@/stores';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'shop.shopping_cart' },
    class: "button-shopping-cart"
  }, {
    default: _withCtx(() => [
      (_unref(shoppingCartStore).totalQuantity > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["num", { small: _unref(shoppingCartStore).totalQuantity > 99 }])
          }, _toDisplayString(_unref(shoppingCartStore).totalQuantity > 99 ? '99+' : _unref(shoppingCartStore).totalQuantity), 3))
        : _createCommentVNode("", true),
      _hoisted_1
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})